var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8662 11H11.1342C11.6102 11 12.0002 10.61 12.0002 10.134V9.866C12.0002 9.39 11.6102 9 11.1342 9H6.8662C6.3892 9 6.0002 9.39 6.0002 9.866V10.134C6.0002 10.61 6.3892 11 6.8662 11ZM15 15C15 15.551 14.552 16 14 16H4C3.449 16 3 15.551 3 15V6H15V15ZM3 2H15C15.552 2 16 2.449 16 3C16 3.551 15.552 4 15 4H3C2.449 4 2 3.551 2 3C2 2.449 2.449 2 3 2ZM18 3C18 1.346 16.654 0 15 0H3C1.346 0 0 1.346 0 3C0 3.883 0.391 4.67 1 5.22V15C1 16.654 2.346 18 4 18H14C15.654 18 17 16.654 17 15V5.22C17.609 4.67 18 3.883 18 3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.b2b4741f7d592215f48f9d1b33fe2d72.svg";
export { ForwardRef as ReactComponent };